import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { GlobalService } from 'src/app/global.service';
import { UserDetailsComponent } from 'src/app/user-list-page/user-details/user-details.component';

@Component({
  selector: 'app-user-hierarchy-table',
  templateUrl: './user-hierarchy-table.component.html',
  styleUrls: ['./user-hierarchy-table.component.css']
})
export class UserHierarchyTableComponent {

  @ViewChild(UserDetailsComponent) 
  private UserDetailsModal!:UserDetailsComponent;

  @Input() isLoading : boolean = false;
  @Input() message : String = "";
  @Input() userList : Array<any> = [];
  @Output() updateSort = new EventEmitter<Sort>();
  @Output() onItemClickEmitter = new EventEmitter<Sort>();
  
  isMobile : boolean = false;

  constructor(
    public globalservice : GlobalService
  ){}

  ngOnInit(){
    this.isMobile = this.globalservice.isMobile();
  }

  onItemClick(data:any){
    this.onItemClickEmitter.emit(data);
  }
  openDetails(data:any, event:Event){
    this.UserDetailsModal.openModal();
    this.UserDetailsModal.getUserDetails(data.id);
    event.stopPropagation();
  }
  sortData(sort:Sort){
    this.updateSort.emit(sort);
  }

}
